/** @format */

import * as React from "react";
import { Flex, Image, Text, useMediaQuery } from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import DOMPurify from "dompurify";

export const About_Business_KR: React.FC = () => {
  const [isSmall] = useMediaQuery([`(max-width: ${theme.breakpoints.md})`]);
  const sanitizer = DOMPurify.sanitize;
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };
  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      backgroundColor={colors.newGray}
      paddingX={basePaddingX}
      paddingY={basePaddingY}
    >
      <Flex
        width="100%"
        maxWidth={theme.breakpoints.mx}
        position={"static"}
        direction={"column"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
      >
        <Text
          wordBreak={"keep-all"}
          fontSize={{
            base: "24px",
            sm: "32px",
            md: "35px",
            lg: "52px"
          }}
          mb={{
            base: "50px",
            sm: "70px",
            md: "80px",
            lg: "100px"
          }}
          fontWeight={"700"}
        >
          {commonInfo.about_business.title}
        </Text>
        <Flex
          flexWrap={isSmall ? "nowrap" : "wrap"}
          flexDirection={isSmall ? "column" : "row"}
          justifyContent={"center"}
          alignItems={isSmall ? "stretch" : "center"}
          gap={{ base: "40px", sm: "60px", md: "20px", lg: "36px" }}
        >
          {commonInfo.about_business.items.map((item, index) => (
            <Flex
              key={index}
              overflow={"hidden"}
              direction={"column"}
              justifyContent={"stretch"}
              width={{
                base: "100%",
                md: "calc(50% - 10px)",
                lg: "calc(50% - 18px)"
              }}
              boxShadow={"xl"}
              borderRadius={"24px"}
              bgColor={colors.white}
            >
              <Image
                width={"100%"}
                height={{
                  base: "180px",
                  sm: "240px",
                  md: "240px",
                  lg: "275px"
                }}
                objectFit={"cover"}
                src={item.img}
                bgColor={colors.black}
              />
              <Flex
                flexGrow={1}
                flexDirection={"column"}
                justifyContent={"space-around"}
                alignItems={"baseline"}
                boxSizing={"content-box"}
                height={{
                  base: "180px",
                  sm: "240px",
                  md: "240px",
                  lg: "275px"
                }}
                paddingX={{
                  base: "16px",
                  sm: "36px"
                }}
                paddingTop={{
                  base: "20px",
                  sm: "32px",
                  md: "40px",
                  lg: "32px"
                }}
                paddingBottom={{
                  base: "30px",
                  sm: "40px",
                  md: "40px",
                  lg: "32px"
                }}
              >
                <Text
                  color={colors.black}
                  fontSize={{
                    base: "20px",
                    sm: "32px",
                    md: "22px",
                    lg: "32px"
                  }}
                  wordBreak={"keep-all"}
                  fontWeight={"700"}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.title)
                  }}
                />
                <Text
                  color={colors.black}
                  fontSize={{
                    base: "14px",
                    sm: "18px",
                    md: "18px",
                    lg: "20px"
                  }}
                  wordBreak={"keep-all"}
                  fontWeight={"400"}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.description)
                  }}
                />
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default About_Business_KR;
